<ng-container [ngSwitch]="format">
    <ng-container *ngSwitchCase="FORMATS.FONT">
        <ng-container *ngTemplateOutlet="font"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="FORMATS.ICON">
        <ng-container *ngTemplateOutlet="icon"></ng-container>
    </ng-container>
</ng-container>

<ng-template #font>
    <span class="icon {{name}} size-{{size}}" [ngClass]="{'is-html': htmlEntity}" [ngStyle]="styles"
        title="{{title}}" [attr.aria-hidden]="ariaHidden" [innerHtml]="htmlEntity | safeHtml">
    </span>
</ng-template>

<ng-template #icon>
    <img [src]="imgSrc" class="svg" [ngClass]="'size-'+size" title="{{title}}" aria-hidden="true" [ngStyle]="styles" />
</ng-template>
